module.exports = __webpack_public_path__ + "img/bg_mrq.43c0e9b3.svg";